import { z } from 'zod';

// AIDEV-NOTE: Schemas CRM compartilhados entre client (formularios) e server (validacao API)

export const PipelineEtapaSchema = z.enum(['novo', 'qualificado', 'proposta', 'ganho', 'perdido']);
export type PipelineEtapa = z.infer<typeof PipelineEtapaSchema>;

export const LeadFormSchema = z.object({
  nome: z.string().min(2, 'Nome deve ter ao menos 2 caracteres'),
  empresa: z.string().optional(),
  valor_estimado: z.number().min(0, 'Valor nao pode ser negativo').optional(),
  probabilidade: z.number().min(0).max(100, 'Probabilidade deve ser entre 0 e 100').optional(),
  estagio: PipelineEtapaSchema,
  proximo_contato_em: z.string().datetime().nullable().optional()
});
export type LeadFormInput = z.infer<typeof LeadFormSchema>;

export const AtividadeTipoSchema = z.enum(['ligacao', 'email', 'tarefa', 'reuniao']);
export type AtividadeTipo = z.infer<typeof AtividadeTipoSchema>;

export const AtividadeFormSchema = z.object({
  tipo: AtividadeTipoSchema,
  descricao: z.string().min(1, 'Descricao obrigatoria').optional(),
  data_prevista: z.string().optional(),
  lead_id: z.string().uuid().optional(),
  cliente_codigo: z.number().int().positive().optional()
});
export type AtividadeFormInput = z.infer<typeof AtividadeFormSchema>;

// AIDEV-NOTE: Tipo Lead (retorno do Supabase) - alinhado com colunas reais da tabela leads_oportunidades
export interface Lead {
  id: string;
  cliente_id: number;
  vendedor_erp_id?: number;
  nome: string;
  empresa?: string;
  origem_erp_id?: number;
  ramo_atividade_erp_id?: number;
  estagio: PipelineEtapa;
  probabilidade?: number;
  valor_estimado?: number;
  cliente_erp_id?: number;
  proximo_contato_em: string | null;
  created_at: string;
  updated_at: string;
}

// AIDEV-NOTE: Tipo Atividade (retorno do Supabase) - interface completa com campos de auditoria
export interface Atividade {
  id: string;
  client_id: number;
  vendedor_id: number;
  lead_id?: string;
  cliente_codigo?: number;
  /** Enriquecido no hook via lookup em sync_clientes — não persiste no banco */
  cliente_razao_social?: string;
  tipo: AtividadeTipo;
  descricao?: string;
  status: 'pendente' | 'realizada' | 'cancelada';
  data_prevista?: string;
  data_realizada?: string;
  created_at: string;
  updated_at: string;
}
